import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["categoryId"];

  setCategoryId(event) {
    this.categoryIdTarget.value = event.params.categoryId;
  }
}
